import { render, staticRenderFns } from "./DisplayDetailUserPanel.vue?vue&type=template&id=651f3741&scoped=true"
import script from "./DisplayDetailUserPanel.vue?vue&type=script&lang=js"
export * from "./DisplayDetailUserPanel.vue?vue&type=script&lang=js"
import style0 from "./DisplayDetailUserPanel.vue?vue&type=style&index=0&id=651f3741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f3741",
  null
  
)

export default component.exports